import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/lib/theme"; // Side-effect: applies stored theme to <html> on first paint
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for offline app-shell + installability
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
